import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import H2 from '../Headings/H2'

const TableOfContent = ({ list }) => {
  const [activeItem, setActiveItem] = useState('')
  const handleClick = (e) => {
    setActiveItem(e.target.id)
  }

  useEffect(() => {
    if (window.location.hash) {
      setActiveItem(window.location.hash)
    } else {
      setActiveItem(list[0].href)
    }
  }, [list])

  return (
    <div>
      <H2 text="Table of Contents" id="tableOfContents" />
      <ul id="table-of-contents" data-testid="table-of-contents">
        {list.map(({ value, href }, k) => {
          return value ? (
            <li key={`${value}-${k}`}>
              <a
                className={classNames(
                  { 'border-blue-550': href === activeItem },
                  `block border-l-4 py-2 pl-6 text-xl font-medium text-black-base`
                )}
                href={`${href}`}
                id={`${href}-${k}`}
                onClick={handleClick}
              >
                {value}
              </a>
            </li>
          ) : null
        })}
      </ul>
    </div>
  )
}

TableOfContent.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default TableOfContent
